type ParameterValue = string | number | undefined | boolean;

export type Params = Record<string, ParameterValue[] | ParameterValue>;

export function applyParams(params: URLSearchParams, source: Params) {
  for (const [key, param] of Object.entries(source)) {
    params.delete(key);
    const values = Array.isArray(param) ? param : [param];
    for (const value of values) {
      if (value !== undefined) {
        params.append(key, value.toString());
      }
    }
  }
}
